import { cookie } from '@sfe/bone-cache';
import { COOKIE_MAIN_DOMAIN } from './config/env';
import { BYBIT_GUID_KEY } from './config/constants';

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export function getGuid() {
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export default () => {
    let guid = cookie.get(BYBIT_GUID_KEY);
    if (!guid || guid.length !== 36) {
        guid = getGuid();
    }

    cookie.set(BYBIT_GUID_KEY, guid, {
        expires: 120,
        domain: COOKIE_MAIN_DOMAIN,
        secure: false,
    });

    return guid;
};
